<template>
  <div class="page-vacancies">
    <div class="page-vacancies__container">
      <div class="page-vacancies__vacancies-info-block">
        <div class="page-vacancies__vacancies-info">
          <h4 class="page-vacancies__vacancies-name">
            <a :href="`/vacancy/${vacancy.id}`" class="page-vacancies__vacancies-link"> {{ vacancy.title }} </a>
          </h4>
          <LabelNew v-if="isNewDate(vacancy.start_published)" class="page-vacancies__new-vacancies-info"></LabelNew>
        </div>
        <div class="h4 color--main-ground-light page-vacancies__vacancies-price" v-if="vacancy.salary_from">
          от {{ getFormattedSalary(vacancy.salary_from) }} <span v-if="vacancy.salary_to"> до {{ getFormattedSalary(vacancy.salary_to) }} </span>  ₽
        </div>
        <div class="h4 color--main-ground-light page-vacancies__vacancies-price" v-else>
          По договоренности
        </div>
      </div>
      <div class="page-vacancies__vacancies-data">
        <div class="page-vacancies__vacancies-location m-t-u color--main-ground-light">
          <IconLocation/>
          {{ vacancy.city }}
        </div>
        <div class="page-vacancies__vacancies-date m-t-u color--main-ground-light">
          <IconCalendar/>
          Опубликовано <span v-if="vacancy.start_published"> {{ getDateFormatISO(vacancy.start_published) }} </span>
        </div>
      </div>
      <div class="page-vacancies__vacancies-detail">
        <p class="page-vacancies__vacancies-description">
          {{ vacancy.description }}
        </p>
      </div>
      <div class="page-vacancies__vacancies-logo">
        <div v-if="vacancy.sponsor.logo">
          <a :href="vacancy.sponsor.site" class="page-vacancies__vacancies-logo-link">
            <img :src="vacancy.sponsor.logo" class="page-vacancies__vacancies-logo-img" alt="logo">
          </a>
        </div>
        <div v-else>
          <p class="page-vacancies__vacancies-logo-text">
            <a href="" class="page-vacancies__vacancies-logo-link">
              {{ vacancy.sponsor.name }}
            </a>
          </p>
        </div>
      </div>
      <div class="page-vacancies__dividing-line"></div>
    </div>
  </div>
</template>

<script>
import IconReload from '../../icons/icon-reload'
import IconLocation from '../../icons/icon-location'
import IconCalendar from '../../icons/icon-calendar'
import LabelNew from './label-new'
import { formatSalary, formatTimeISO } from "../../../app/utils/utils";
import { DateTime, Interval } from "luxon";

export default {
  name: 'vacancies',
  components: {
    IconReload,
    IconLocation,
    IconCalendar,
    LabelNew
  },

  props: {
    vacancy: { type: Object, default: () => {}, required: false },
  },

  data() {
    return {}
  },

  methods: {
    getDateFormatISO(date) {
      return formatTimeISO(date)
    },

    getFormattedSalary(salary) {
      return formatSalary(salary)
    },

    isNewDate(date) {
      // TODO: наверное стоит высчитывать это в методе computed
      const publishedDate = DateTime.fromISO(date);
      const today = DateTime.local();
      const intervalInMs = Interval.fromDateTimes(publishedDate, today).length();
      const interval = Math.floor(intervalInMs/(86400 * 1000))

      return interval < 7
    },
  }
}
</script>
